import yup from '~/utils/validationMessages'

import { errors } from './errors'

type LoginField = {
  title: string
  name: 'email' | 'password'
  type: string
}

export const LOGIN_FORM_FIELDS: LoginField[] = [
  {
    title: 'Email',
    name: 'email',
    type: 'email',
  },
  {
    title: 'Password',
    name: 'password',
    type: 'password',
  },
]

export const validationFields = {
  email: yup.string().email().required(),
  firstName: yup.string().max(100).required(),
  lastName: yup.string().max(100).required(),
  password: yup.string().required(),
  phoneNumber: yup
    .string()
    .nullable()
    .notRequired()
    .when([], {
      is: (value: string | null | undefined) => !!value,
      then: schema =>
        schema
          .matches(/^\+?\d*$/, errors.validation.mixed.integers_only)
          .min(9)
          .max(13),
    }),
  city: yup
    .string()
    .matches(/^[A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż]+$/, errors.validation.mixed.letters_only)
    .required(),
}

export const loginSchema = yup.object().shape({
  email: validationFields.email,
  password: validationFields.password,
})
